import slugs from "./slugs.json";

export const DEFAULT_LOCALE = "de";

// Reihenfolge = Reihenfolge im Sprachmenü
export const LOCALES = [
  { code: "de", name: "Deutsch", tag: "de-DE", dir: "ltr" },
  { code: "en", name: "English", tag: "en-GB", dir: "ltr" },
  { code: "tr", name: "Türkçe", tag: "tr-TR", dir: "ltr" },
  { code: "ru", name: "Русский", tag: "ru-RU", dir: "ltr" },
  { code: "pl", name: "Polski", tag: "pl-PL", dir: "ltr" },
  { code: "hr", name: "Hrvatski", tag: "hr-HR", dir: "ltr" },
  { code: "it", name: "Italiano", tag: "it-IT", dir: "ltr" },
  { code: "ar", name: "العربية", tag: "ar", dir: "rtl" },
];

export const LOCALE_CODES = LOCALES.map((l) => l.code);
export const ROUTE_KEYS = Object.keys(slugs.de);

export const getLocale = (code) => LOCALES.find((l) => l.code === code) ?? LOCALES[0];

export const prefixFor = (code) => (code === DEFAULT_LOCALE ? "" : `/${code}`);

// URL-Pfad einer Seite in einer Sprache, z. B. pathFor("tr", "contact") -> "/tr/iletisim"
export const pathFor = (code, key, hash = "") => {
  const slug = slugs[code]?.[key] ?? slugs[DEFAULT_LOCALE][key] ?? "";
  const base = `${prefixFor(code)}/${slug}`.replace(/\/+$/, "") || "/";
  return hash ? `${base}#${hash}` : base;
};

// Sprache und Seiten-Schlüssel aus einem Pfad ermitteln
export const resolvePath = (pathname) => {
  const parts = pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  let code = DEFAULT_LOCALE;
  if (parts.length && LOCALE_CODES.includes(parts[0]) && parts[0] !== DEFAULT_LOCALE) {
    code = parts.shift();
  }
  const slug = parts[0] ?? "";
  const key = ROUTE_KEYS.find((k) => slugs[code][k] === slug);
  return { code, key: parts.length <= 1 ? key : undefined };
};

export { slugs };
